(function () {
  'use strict';

  angular
    .module('app.segmentationReportIndustry')
    .controller('segmentationReportIndustryCtrl', segmentationReportIndustryCtrl);

  segmentationReportIndustryCtrl.$inject = ['measureService', 'segmentationReportIndustryService', '$scope', '$rootScope'];
  function segmentationReportIndustryCtrl(measureService, segmentationReportIndustryService, $scope, $rootScope) {

    var pieChartConfigHaveLegend = {
      options: {
        chart: {
          type: 'pie',
          backgroundColor: null,
          marginBottom: 1,
          marginLeft: 0,
          marginRight: 200,
          marginTop: 0
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          symbolHeight: 12,
          symbolWidth: 12,
          symbolRadius: 6,
          verticalAlign:'middle',
          align: 'right',
          layout: 'vertical',
          width: 170,
          itemStyle: {
            fontWeight: '500'
          },
          labelFormatter: function () {
            return '<span style="display: block">'
              + this.name + ' - '
              + Math.round(this.y*1000)/10 +'%' +
              '</span>';}
        }
      },
      series: [{
        size: '100%',
        innerSize: '85%'
      }],
      title: {
        text: 'NATIONALITY',
        style: {
          fontSize: '16px',
          color: '#4B5567',
          fontFamily: 'ProximaNovaSemibold'
        },
        align: 'left'
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Date'
        }
      },
      noData: 'Pending Data...',
      loading: true
    };

    var pieChartConfigForPrint = {
      options: {
        chart: {
          type: 'pie',
          backgroundColor: null,
          marginBottom: 1,
          marginLeft: 0,
          marginRight: 200,
          marginTop: 0
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          symbolHeight: 12,
          symbolWidth: 12,
          symbolRadius: 6,
          verticalAlign:'middle',
          align: 'right',
          layout: 'vertical',
          width: 170,
          itemStyle: {
            fontWeight: '500',
            fontSize: '20px'
          },
          labelFormatter: function () {
            return '<span style="display: block">'
              + this.name + ' - '
              + Math.round(this.y*1000)/10 +'%' +
              '</span>';}
        }
      },
      series: [{
        size: '100%',
        innerSize: '85%'
      }],
      title: {
        text: 'NATIONALITY',
        style: {
          fontSize: '23px',
          color: '#4B5567',
          fontFamily: 'ProximaNovaSemibold'
        },
        align: 'left'
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Date'
        }
      },
      noData: 'Pending Data...',
      loading: true
    };

    var barChartConfig  = {
      options: {
        chart: {
          type: 'column',
          zoomType: 'x'
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: false
            },
            showInLegend: false
          },
          series: {
            borderWidth: 0,
            dataLabels: {
              allowOverlap: true,
              enabled: true,
              crop: false,
              overflow: 'none',
              format: '{point.y:.0f}'
            },
            pointWidth: 40,
            states: {
                hover: {
                    enabled: false
                }
            }
          }
        },
        credits: {
          enabled: false
        }
      },
      series: [],
      title: {
        text: 'PLATFORMS',
        textAnchor: 'left',
        style: {
          fontSize: '16px',
          color: '#4B5567',
          fontFamily: 'ProximaNovaSemibold'
        }
      },
      xAxis: {
        type: 'category',
        tickLength: 0,
        labels: {

        }
      },
      yAxis: {
        title: {
          text: false
        },
        labels: {
          enabled: false
        }
      },
      noData: 'Pending Data...',
      loading: true
    };

    var barChartConfigForPrint  = {
      options: {
        chart: {
          type: 'column',
          zoomType: 'x'
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: false
            },
            showInLegend: false
          },
          series: {
            borderWidth: 0,
            dataLabels: {
              allowOverlap: true,
              enabled: true,
              crop: false,
              overflow: 'none',
              format: '{point.y:.0f}',
              style: {
                  fontSize: '17px',
                  fontWeight: '600',
                  fontFamily: 'ProximaNovaRegular'
              }
            },
            pointWidth: 40,
            states: {
                hover: {
                    enabled: false
                }
            }
          }
        },
        credits: {
          enabled: false
        }
      },
      series: [],
      title: {
        text: 'PLATFORMS',
        textAnchor: 'left',
        style: {
          fontSize: '23px',
          color: '#4B5567',
          fontFamily: 'ProximaNovaSemibold'
        }
      },
      xAxis: {
        type: 'category',
        tickLength: 0,
        labels: {

        }
      },
      yAxis: {
        title: {
          text: false
        },
        labels: {
          enabled: false
        }
      },
      noData: 'Pending Data...',
      loading: true
    };

    $scope.$on('refreshDashboard', function(event, args) {
      getDataSegmentationReportIndustry();
    });

    function generateIndustryData(industries) {
      $scope.industries = {};
      var pieChart = _.get(industries, 'pieChart');
      var config = angular.copy(pieChartConfigHaveLegend);
      config.options.chart.width = 485;
      config.options.legend.maxHeight = 232;
      config.options.legend.x = -35;
      config.options.legend.y = 5;
      config.options.legend.itemMarginBottom = 1.5;

      var dataPieChart = [];
      _.forEach(pieChart, function (item) {
        if(item.name != "NA" && Math.round(item.value*1000)/10 != 0){
          dataPieChart.push({name: item.name, y: item.value});
        }        
      });
      config.series[0].data = dataPieChart;
      config.series[0].size = '80%';
      config.title.text = 'INDUSTRIES BY INFLUENCERS';
      config.title.style.marginBottom = '16px';
      config.title.x = 25;

      $scope.industries.pieChart = config;

      //for print pie chart
      var pieConfig = angular.copy(pieChartConfigForPrint);
      pieConfig.options.chart.width = 485;
      pieConfig.options.legend.maxHeight = 232;
      pieConfig.options.legend.x = -35;
      pieConfig.options.legend.y = 5;
      pieConfig.options.legend.itemMarginBottom = 1.5;

      pieConfig.series[0].data = dataPieChart;
      pieConfig.series[0].size = '58%';
      pieConfig.title.text = 'INDUSTRIES BY INFLUENCERS';
      pieConfig.title.style.marginBottom = '16px';
      pieConfig.title.x = 25;

      $scope.industries.pieChartForPrint = pieConfig;

      var barChart = _.get(industries, 'barChart');
      var barConfig = angular.copy(barChartConfig);
      barConfig.options.chart.width = 485;
      barConfig.options.plotOptions.series.pointWidth = 25;
      barConfig.options.plotOptions.column.colorByPoint = true;
      barConfig.xAxis.labels.rotation = 90;
      barConfig.xAxis.labels.style = {
        fontSize: '13px',
        color: '#333333',
        fontWeight: '600',
        fontFamily: 'ProximaNovaRegular'
      };
      var barSeries = {
        //name: 'Platforms',
        data: []
      };
      _.forEach(barChart, function (item) {
        // barSeries.data.push({name: item.name, y: item.value, color: item.color});
        if(item.name != "NA" && Math.round(item.value) != 0){
          barSeries.data.push({name: item.name, y: item.value});
        }        
      });
      barConfig.series.push(barSeries);
      barConfig.title.text = 'INDUSTRIES BY ENGAGEMENT';
      $scope.industries.barChart = barConfig;
      // $scope.$broadcast('highchartsng.reflow');

      //for print bar chart
      var barConfig2 = angular.copy(barChartConfigForPrint);
      barConfig2.options.chart.width = 485;
      barConfig2.options.plotOptions.series.pointWidth = 25;
      barConfig2.options.plotOptions.column.colorByPoint = true;
      barConfig2.xAxis.labels.rotation = 90;
      barConfig2.xAxis.labels.style = {
        fontSize: '17px',
        color: '#333333',
        fontWeight: '600',
        fontFamily: 'ProximaNovaRegular'
      };
      barConfig2.series.push(barSeries);
      barConfig2.title.text = 'INDUSTRIES BY ENGAGEMENT';
      $scope.industries.barChartForPrint = barConfig2;
    }

    function getDataSegmentationReportIndustry() {
      var params = $rootScope.saveParams;
      if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
        return;
      }
      params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

      getSegmentIndustryData(params);
    }

    function getSegmentIndustryData(params){
      segmentationReportIndustryService.getSegmentIndustryData(params)
        .then(function(response){
            generateIndustryData(response.industries);
        })
        .catch(function(message){
        	$scope.industries = null;
        })
        .finally(function(){
          $rootScope.$broadcast('sectionLoaded');
        })            
    }
    
    // first initiating
    getDataSegmentationReportIndustry();
  }
})();